<!-- 登陆组件 -->
<template>
  <div class="login-component">
    <p class="p">蓝数通</p>
    <p class="p">LET DATA SPEAK</p>
    <div class="login-group">
      <div class="login-item">
        <input @mouseover="hoverIpt=1" @mouseout="hoverIpt=0" :class="hoverIpt===1?'hover-ipt':''" @focus="hoverIpt=1" class="item-ipt" v-model="info.number" type="text" placeholder="员工编号"/>
      </div>
      <div class="login-item">
        <input @mouseover="hoverIpt=3" @mouseout="hoverIpt=0" :class="hoverIpt===3?'hover-ipt':''" @focus="hoverIpt=3" class="item-ipt" v-model="info.password" type="password" placeholder="密码">
      </div>
      <div class="login-item">
        <input @mouseover="hoverIpt=2" @mouseout="hoverIpt=0" :class="hoverIpt===2?'hover-ipt':''" @focus="hoverIpt=2" class="item-ipt item-verification" maxlength="4" @input="verficate" v-model="info.verification" type="text" placeholder="请输入验证码">
        <img class="verification" :src="verificationImg" />
        <img class="refresh cursor-pointer" :src="isRefresh" @mouseover="overRefresh" @mouseout="outRefresh" @click="refreshVerification">
      </div>
      <div class="login-item btn-item cursor-pointer" :class="btnFoucus ? 'foucus' : 'no-foucus'" @mouseover="btnFoucus=true" @mouseout="btnFoucus=false" @click="clickLogin">
        {{loginText}}
      </div>
      <p class="error-text">{{loginPageLoginErrorMsg}}</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import CryptoJS from 'crypto-js'
import {refresh, refreshActive} from 'utils/imgUrl'
import {login, checkValidationCode} from 'utils/api/login'
import {getTimeStamp} from 'utils/util'
import Cookies from 'js-cookie'
import {Message} from 'element-ui'
import { loginComponent_url,loginComponent_jumpToIndex} from "../env_config.js"

export default {
  data () {
    return {
      // 测试环境配置
      url: loginComponent_url, // 验证码图片
      jumpToIndex:loginComponent_jumpToIndex,
      // 生产环境配置
      // url: 'http://domp.bluemoon.com.cn/bd-domp-service/membership/pcrimg_v2?date=', // 验证码图片
      // jumpToIndex: 'http://domp.bluemoon.com.cn/bd-portal-view/index.html#/index',
      hoverIpt: 0, // 文本框hover
      isRefresh: refresh, // 刷新按钮
      btnFoucus: false, // 登陆按钮
      loginPageLoginErrorMsg: '', // 登陆提示
      loginText: '登录', // 按钮名
      info: { // 登录信息
        number: null,
        password: null,
        verification: ''
      },
      aesKey: 'BLUEv80r0605MOON',
      validationCodeSure: -1
    }
  },
  methods: {
    overRefresh () {
      this.isRefresh = refreshActive
    },
    outRefresh () {
      this.isRefresh = refresh
    },
    // 验证码api
    verficate () {
      const _this = this
      if (this.info.verification.length === 4) {
        let data = {
          'validationCode': this.info.verification
        }
        checkValidationCode(data).then(res => {
          this.validationCodeSure = res.respCode
          _this.loginPageLoginErrorMsg = (res.respCode !== '100') ? res.respDesc : ''
        })
      }
    },
    // 验证输入信息
    checkform () {
      if (this.info.number === null || this.info.number === '') {
        this.loginPageLoginErrorMsg = '请输入您的员工编号'
        return false
      }
      if (this.info.password === null || this.info.password === '') {
        this.loginPageLoginErrorMsg = '请输入您的密码'
        return false
      }
      const numExp = /^[0-9]+$/
      const wordExp = /^[a-zA-Z]+$/
      if (this.info.password.length < 8 || this.info.password.length > 18 ||
        numExp.test(this.info.password) || wordExp.test(this.info.password)) {
        this.loginPageLoginErrorMsg = '密码8-18位，数字和字母的组合'
        return false
      }
      if (this.info.verification === null || this.info.verification === '' || this.info.verification.length !== 4) {
        this.loginPageLoginErrorMsg = '验证码错误'
        return false
      } else {
        var result = this.validationCodeSure
        if (result === -1 || result === '-1') {
          this.loginPageLoginErrorMsg = '验证码错误'
          return false
        }
      }
      this.loginPageLoginErrorMsg = ''
      return true
    },
    // 登陆 api
    doLogin (username, password, isCookieLogin, validationCode) {
      const _this = this
      _this.loginText = '登录中...'
      let params = {
        username,
        password,
        isCookieLogin,
        validationCode,
        brand: '999'
      }
      this.$store.dispatch('login', params).then((res) => {
        if (res.respCode === '-1') {
          Message({
            message: res.respDesc,
            type: 'error'
          })
          _this.loginText = '登录'
        } else if (res.respCode === '100') {
          // _this.$router.push({path: '/index'})
          Cookies.set('dopm_user_name', params.username, {expires: 30})
          Cookies.set('dopm_user_password', params.password, {expires: 30})
          Cookies.set('token', res.token, {expires: 7})
          let name = res.respData[0].user_name || ''
          Cookies.set('name', name, {expires: 7})
          _this.loginText = '登录'

          window.location.href = _this.jumpToIndex
        } else if (res.respCode === '2204') {
          alert('您的密码强度较弱，请先到月亮天使平台或SFA平台修改密码，凭新密码再进行登录。')
          _this.refreshVerification()
          _this.loginText = '登录'
        } else {
          _this.loginPageLoginErrorMsg = res.respDesc
          _this.refreshVerification()
          _this.loginText = '登录'
        }
      }).catch(error => {
        console.log(error)
        console.log('向服务器发送请求失败')
        _this.loginText = '登录'
      })
    },
    clickLogin () {
      let flag = this.checkform()
      if (!flag) {
        return
      }
      let key = CryptoJS.enc.Utf8.parse(this.aesKey)
      let iv = CryptoJS.enc.Utf8.parse(this.aesKey)
      let srcs = CryptoJS.enc.Utf8.parse(this.info.password)
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {iv, mode: CryptoJS.mode.CBC})
      let encPassword = encrypted.toString()
      this.doLogin(this.info.number, encPassword, 'Y', this.info.verification)
    },

    // 更换验证码
    changeVerifocation () {
      let date = getTimeStamp()
      this.verificationImg = this.url + date
    },
    refreshVerification () {
      this.info.verification = ''
      this.changeVerifocation()
    },
    // enter按下点击登陆
    loginKeydown (key) {
      key.keyCode === 13 && this.clickLogin()
    }
  },
  created () {
    const _this = this
    this.changeVerifocation()
    // 监听enter
    window.addEventListener('keydown', _this.loginKeydown, false)
    console.log("login check......");
    console.log(this.jumpToIndex);
  },
  beforeDestroy () {
    const _this = this
    // 删除监听enter
    window.removeEventListener('keydown', _this.loginKeydown)
  }
}
</script>
<style lang="less">
@import "~assets/style/variable";
@import "~assets/style/mixin";
.login-component {
  width: 250px;
  .p {
    font-size: @font-size-large;
    padding: 0 20px;
    line-height: 25px;
  }
}
.login-group {
  margin-top: 40px;
  .login-item {
    width: 250px;
    margin-bottom: 12px;
    .flex-space-between;
    .item-ipt {
      border-radius: 20px;
      height: 40px;
      width: 210px;
      font-size: @font-size-medium;
      padding: 0 20px;
      background: #fff;
      opacity: 0.8;
      color: #333;
      .cursor-pointer;
    }
    .item-ipt::-webkit-input-placeholder { /* WebKit browsers */
      color:#666;
    }
    .item-ipt:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color:#666;
    }
    .item-ipt::-moz-placeholder { /* Mozilla Firefox 19+ */
      color:#666;
    }
    .item-ipt:-ms-input-placeholder { /* Internet Explorer 10+ */
      color:#666;
    }
    .hover-ipt {
      opacity: 1 !important;
    }
    .item-verification {
      width: 84px;
    }
  }
  .verification {
    width: 70px;
    height: 28px;
  }
  .btn-item {
    height: 40px;
    width: 250px;
    text-align: center;
    line-height: 40px;
    border-radius: 20px;
    margin-top: 40px;
    .flex-center;
  }
  .no-foucus {
    border: 1px solid #fff;
  }
  .foucus {
    background: @color-theme;
    border: 1px solid @color-theme;
  }
  .refresh {
    width: 32px;
    height: 32px;
  }
  .login-btn {
    margin-top: 30px;
  }
  .btn-item {
    text-align: center;
  }
}
.error-text {
  margin-top: 20px;
  color: @color-sub-theme;
  font-size: @font-size-small;
  width: 250px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/loginComponent.vue